import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CogFilledSvg = function CogFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m22 9.868-2.08 1.22c.109.77.109 1.552 0 2.322L22 14.631l-2.973 5.237-2.08-1.222a8 8 0 0 1-1.975 1.163v2.44H9.028v-2.44a8 8 0 0 1-1.977-1.163l-2.079 1.222L2 14.63l2.08-1.22a8.3 8.3 0 0 1 0-2.322L2 9.868 4.972 4.63l2.08 1.223A8 8 0 0 1 9.028 4.69V2.249h5.944v2.44c.716.292 1.381.686 1.977 1.164l2.079-1.222zm-10 5.637c.42 0 .836-.084 1.224-.248a3.2 3.2 0 0 0 1.039-.706c.297-.302.533-.661.694-1.056a3.31 3.31 0 0 0-.694-3.548 3.2 3.2 0 0 0-1.039-.706 3.15 3.15 0 0 0-3.488.706c-.6.61-.937 1.439-.937 2.302 0 .864.337 1.692.937 2.302s1.415.954 2.263.954",
    clipRule: "evenodd"
  }));
};
export var CogFilled = function CogFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CogFilledSvg
  }));
};